import React from 'react';
import UserContext from '../../contexts/UserContext';
import { withStyles } from '@material-ui/core/styles';
import UserCard from '../../components/UserCard';
import StoreSelector from '../../components/StoreSelector';
import PrivateBlock from '../../components/PrivateBlock';
import MenuList from './MenuList';
import DashboardContext from '../../contexts/DashboardContext';

const StoreSelectorWrapper = withStyles(theme => ({
  root: { borderBottom: `solid ${theme.palette.primary.light} 1px`, padding: '10px 5px' }
}))(({ classes }) => {
  const { service, state } = React.useContext(DashboardContext);
  return (
    <div className={classes.root}>
      <StoreSelector
        value={state.context.currentStore}
        onChange={(storeId, store) => {
          service.send({ type: 'CHANGE_STORE', value: { storeId, store } });
        }}
      />
    </div>
  );
});

export default function DrawerContent() {
  const { currentUser } = React.useContext(UserContext);
  // id: 'test',
  // fullName: 'Kim ThorBurn',
  // title: 'Cosmetic Consultant',
  // photoUrl: 'https://material-ui.com/static/images/avatar/1.jpg',
  return (
    <>
      <UserCard id="current-user-card" user={currentUser} />
      <PrivateBlock allowedGroups={['Admins']}>
        <StoreSelectorWrapper />
      </PrivateBlock>
      <MenuList />
    </>
  );
}
